const KEY = "roxy-theme";
const listeners = new Set();

export function getTheme() {
    const stored = localStorage.getItem(KEY);
    if (stored === "dark" || stored === "light") return stored;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(t) {
    document.documentElement.classList.toggle("dark", t === "dark");
    listeners.forEach((f) => f(t));
}

export function toggleTheme() {
    const next = getTheme() === "dark" ? "light" : "dark";
    localStorage.setItem(KEY, next);
    applyTheme(next);
    return next;
}

export function onTheme(f) {
    listeners.add(f);
    return () => listeners.delete(f);
}

export function initTheme() {
    applyTheme(getTheme());
}
